import { useQuery } from '@tanstack/react-query';

import addUserData from '~/utils/addUserData';

export const vendorOfferPaymentsQueryKeys = {
  all: ['vendorOfferPayments'],
  withUserData: (paymentIds: Array<string>) => [...vendorOfferPaymentsQueryKeys.all, 'withUserData', paymentIds],
};

interface UseEnrichPaymentsWithUserDataParams {
  payments: Array<Record<string, unknown>>;
  userField: string;
}

export function useEnrichPaymentsWithUserData({ payments, userField }: UseEnrichPaymentsWithUserDataParams) {
  const paymentIds = payments.map((p) => String(p.id || p.id_vendor_offer_payment)).sort();

  return useQuery({
    queryKey: vendorOfferPaymentsQueryKeys.withUserData(paymentIds),
    queryFn: async () => {
      return await addUserData(payments, userField);
    },
    enabled: payments.length > 0,
    gcTime: 0,
    staleTime: 0,
  });
}
